<template>
    <div class="onboarding-wrapper" v-if="doctor && doctor.isCertified && doctor.onboardingStep < 5">
        <div class="onboarding">
            <div class="bubble">
                <div class="bubble-text" v-if="doctor.onboardingStep == 0">
                    <div v-html="$t('step_0_text', {name: doctor.lastName})"></div>

                    <router-link :to="{ name: 'doctor.availabilities' }" class="button is-primary mt-5" v-on:click.native="setOnboardingStep(doctor.onboardingStep + 1)" v-text="$t('step_0_button')"></router-link>
                </div>
                <div class="bubble-text" v-if="doctor.onboardingStep == 1">
                    <div v-if="$route.name == 'doctor.availabilities'">
                        <div v-html="$t('step_1_text')"></div>

                        <router-link :to="{ name: 'doctor.dashboard' }" class="button is-primary mt-5" v-on:click.native="setOnboardingStep(doctor.onboardingStep + 1)" v-text="$t('step_1_button')"></router-link>
                    </div>
                    <div v-else>
                        <div v-html="$t('step_1_helper_text')"></div>

                        <router-link :to="{ name: 'doctor.availabilities' }" class="button is-primary mt-5" v-text="$t('step_1_helper_button')"></router-link>
                    </div>
                </div>
                <div class="bubble-text" v-if="doctor.onboardingStep == 2">
                    <div v-if="$route.name == 'doctor.dashboard'">
                        <div v-html="$t('step_2_text')"></div>

                        <router-link :to="{ name: 'doctor.emergencies' }" class="button is-primary mt-5" v-on:click.native="setOnboardingStep(doctor.onboardingStep + 1)" v-text="$t('step_2_button')"></router-link>
                    </div>
                    <div v-else>
                        <div v-html="$t('step_2_helper_text')"></div>

                        <router-link :to="{ name: 'doctor.dashboard' }" class="button is-primary mt-5" v-text="$t('step_2_helper_button')"></router-link>
                    </div>
                </div>
                <div class="bubble-text" v-if="doctor.onboardingStep == 3">
                    <div v-if="$route.name == 'doctor.emergencies'">
                        <div v-html="$t('step_3_text')"></div>

                        <button class="button is-primary mt-5" @click.prevent="setOnboardingStep(doctor.onboardingStep + 1)" v-text="$t('step_3_button')"></button>
                    </div>
                    <div v-else>
                        <div v-html="$t('step_3_helper_text')"></div>

                        <router-link :to="{ name: 'doctor.emergencies' }" class="button is-primary mt-5" v-text="$t('step_3_helper_button')"></router-link>
                    </div>
                </div>
                <div class="bubble-text" v-if="doctor.onboardingStep == 4">
                    <div>
                        <div v-html="$t('step_4_text')"></div>

                        <button class="button is-primary mt-5" @click.prevent="setOnboardingStep(doctor.onboardingStep + 1)" v-text="$t('step_4_button')"></button>
                    </div>
                </div>
            </div>
            <img src="/static/img/mascot/z.png" alt="Tooddoc Mascot" width="90px">
        </div>
    </div>
</template>

<script>
import helpers from '@/mixins/helpers'

import doctorRepository from '@/data/DoctorRepository'

export default {
    name: 'onboarding',

    mixins: [helpers],

    methods: {
        setOnboardingStep(step) {
            this.doctor.onboardingStep = step

            doctorRepository.update(this.doctor.id, {onboardingStep: step}, () => {
                // DO nothing
            }, (error) => {
                this.alertError(error.message)
            })
        }
    }
}
</script>
<style lang="scss">
    .onboarding-wrapper {

    }

    .onboarding {
        position: relative;

        .bubble {
            background: #3277cb;
            border: 2px solid #00538c;
            border-radius: 5px;
            color: #fff;
            margin-bottom: 15px;
            position: relative;

            .bubble-text {
                padding: 15px;
            }

            &::before {
                content: ' ';
                position: absolute;
                width: 0;
                height: 0;
                left: 28px;
                right: auto;
                top: auto;
                bottom: -24px;
                border: 12px solid;
                border-color: #00538c transparent transparent;
            }

            &::after {
                content: ' ';
                position: absolute;
                width: 0;
                height: 0;
                left: 32px;
                right: auto;
                top: auto;
                bottom: -16px;
                border: 8px solid;
                border-color: #3277cb transparent transparent;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Doctor/Onboarding.vue